module.exports = __webpack_public_path__ + "static/media/faisal.362895db.jpeg";